import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
    selector: 'app-info-popover',
    templateUrl: './info-popover.component.html',
    styleUrl: './info-popover.component.scss',
    standalone: false
})
export class InfoPopoverComponent {
  @Input() header: string = '';
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  toggle() {
    this.isVisible = !this.isVisible;
    this.isVisibleChange.emit(this.isVisible);
  }

  close() {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.isVisible) {
      this.close();
    }
  }
}